/*
  Scene index for keeping track of created scenes.
*/
module.exports = [];



//////////////////
// WEBPACK FOOTER
// ./node_modules/aframe/src/core/scene/scenes.js
// module id = 252
// module chunks = 0